import styled from '@emotion/styled';
interface TabButtonProps {
	isActive?: boolean; // isActive를 선택적 prop으로 정의
}
export const MainWrapper = styled.main`
	padding-top: 0px;
	position: relative;

	.container {
		width: 100%;
		position: relative;
	}
`;

export const MainBanner = styled.article`
	padding: 0;
	min-height: 50rem;
	height: 88rem;
	color: #fff;
	position: relative;

	@media screen and (max-width: 900px) {
		max-height: 50rem;
	}

	.swiper {
		width: 100%;
		height: 100%;
	}

	.swiper-slide {
		width: 100% !important;
		height: 100% !important;
		position: relative;
	}

	.first {
		width: 100%;
		position: relative;
		height: 100%;
	}

	.first_background {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.textBoxWrapper {
		position: absolute;
		top: 36.7rem;
		width: 100%;
		z-index: 10;
		@media screen and (max-width: 900px) {
			top: 14.9rem;
		}
		letter-spacing: -2.56px;
	}

	.textBox {
		display: flex;
		flex-direction: column;
		gap: 2rem;
		max-width: 135rem;
		width: 100%;
		margin: 0 auto;
		padding: 0 2rem;

		.title {
			color: #fff;
			text-shadow: 0 0 54px rgba(0, 0, 0, 0.78);
			font-size: 6.4rem;
			font-weight: ${(props) => props.theme.fontWeight.weightBold};
			line-height: 110%;
			letter-spacing: -0.6px;
			align-self: stretch;

			@media screen and (max-width: 900px) {
				font-size: 3.4rem;
			}
		}

		.description {
			text-shadow: 0 0 18px rgba(0, 0, 0, 0.78);
			font-size: 18px;
			font-weight: ${(props) => props.theme.fontWeight.weightRegular};
			line-height: 140%;
			letter-spacing: -0.6px;
			word-break: keep-all;
			@media screen and (max-width: 900px) {
				font-size: ${(props) => props.theme.fontSize.sizeMd};
			}
		}

		.pagination-container {
			margin-top: 2rem;
		}
	}
	.swiper-pagination_custom {
		position: absolute;
		bottom: 28%;
		left: 0;
		right: 0;
		display: flex;

		max-width: 135rem;
		width: 100%;
		margin: 0 auto;
		z-index: 10;
		@media screen and (max-width: 900px) {
			bottom: 25%;
		}
		@media screen and (max-width: 412px) {
			bottom: 10%;
		}
		@media screen and (max-width: 345px) {
			bottom: 2%;
		}
		.swiper-pagination {
			gap: 2.2rem;
			padding: 0 2rem;
			display: flex;
		}
	}

	/* 페이지네이션 점 스타일링 */
	.swiper-pagination-bullet {
		width: 12px;
		height: 12px;
		background: white;
		opacity: 0.7;
		display: inline-block;
		border-radius: 50%;
		transition: all 0.3s ease;
		border: 1px solid #adb5bd; /* 파란색 - 이미지와 일치하도록 조정 */
		margin: 0 !important;
	}
	.swiper-pagination-bullet-active {
		background: #003399; /* 파란색 - 이미지와 일치하도록 조정 */
		opacity: 1;
	}

	/* 네비게이션 화살표 스타일링 (옵션) */
	.swiper-button-next,
	.swiper-button-prev {
		display: none;
	}
`;
export const Description = styled.section<{ transparent?: boolean; compactBottom?: boolean; tightGap?: boolean }>`
	padding: ${({ compactBottom }) => (compactBottom ? '6rem 0 3rem' : '8rem 0')};
	margin: 0 auto;
	max-width: 135rem;
	width: 100%;
	background-color: ${({ transparent }) => (transparent ? 'transparent' : '#fff')};
	display: flex;
	flex-direction: column;
	gap: ${({ tightGap }) => (tightGap ? '1.6rem' : '3.2rem')};
	@media screen and (max-width: 1370px) {
		padding: ${({ compactBottom }) => (compactBottom ? '6rem 2rem 3rem' : '8rem 2rem')};
	}
	@media screen and (max-width: 600px) {
		padding: ${({ compactBottom }) => (compactBottom ? '3.2rem 1.6rem 2rem' : '4rem 1.6rem')};
		gap: ${({ tightGap }) => (tightGap ? '1.2rem' : '2rem')};
	}
	.main_description_title {
		color: #212529;
		text-align: center;
		display: flex;
		flex-direction: column;
		gap: 1.6rem;
		@media screen and (max-width: 900px) {
			text-align: left;
		}
		.description_title {
			text-align: left;
			font-size: ${(props) => props.theme.fontSize.size6xl};
			font-weight: ${(props) => props.theme.fontWeight.weightSemi};
			line-height: 130%;
			letter-spacing: -0.6px;
			@media screen and (max-width: 900px) {
				font-size: ${(props) => props.theme.fontSize.size4xl};
			}
		}
		.description_sub_title {
			text-align: left;
			font-size: ${(props) => props.theme.fontSize.sizeXl};
			font-weight: ${(props) => props.theme.fontWeight.weightRegular};
			line-height: 180%;
			letter-spacing: -0.8px;
			@media screen and (max-width: 660px) {
				br {
					display: none;
				}
			}
		}
	}
	.greeting_box {
		display: flex;
		align-items: center;
		gap: 2rem; /* 이미지와 텍스트 사이 간격 */
		justify-content: center; /* 가운데 정렬 */
		margin-top: 2rem;
		.greeting_img img {
			width: 400px; /* 원하는 크기로 조절 */
			height: 400px;
			object-fit: cover;
		}
		.greeting_text {
			display: flex;
			flex-direction: column;
			gap: 0.5rem;
		}
		.greeting_name {
			font-size: 2rem; /* 큼 */
			font-weight: bold;
		}

		.greeting_position {
			display: flex;
			align-items: baseline; /* 글자 크기 달라도 자연스럽게 */
			font-size: 1.2rem; /* 중간 */
			color: #555;
		}

		.greeting_message {
			font-size: 1rem; /* 작음 */
			color: #888;
		}
	}
`;

export const CardList = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	align-items: stretch; /* 각 카드가 동일한 높이로 채우도록 */

	@media screen and (max-width: 1100px) {
		grid-template-columns: repeat(2, 1fr);
	}
	@media screen and (max-width: 420px) {
		grid-template-columns: repeat(1, 1fr);
	}
	/* .border-bottom {
		border-bottom: 1px solid #e9ecef;
	}
	.border-left {
		border-left: 1px solid #e9ecef;
	}
	.border-right {
		border-right: 1px solid #e9ecef;
	}
	.dark {
		background-color: #f1f3f5;
	} */
`;

export const CardWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.2rem; /* 타이틀-서브타이틀 간격 확대 */
	order: 2;
	align-items: center; /* 가운데 정렬 */
	text-align: center; /* 텍스트 가운데 */
`;
export const CardTitle = styled.div`
	font-size: 28px; /* 요청: 타이틀 28px */
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	letter-spacing: -0.6px;
	display: flex;
	align-items: center;
`;

export const ImgBox = styled.div`
	display: flex;
	max-width: 8rem;
	img {
		width: 100%;
	}
`;
export const ImgBoxWrapper = styled.div`
	display: flex;
	justify-content: center;
`;
export const CardSubTitle = styled.p`
	font-size: 20px; /* 요청: 서브타이틀 20px */
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%;
	letter-spacing: -0.6px;
`;

export const Notice = styled.section`
	// padding: 8rem 0;
	/* margin: 0 auto;
	max-width: 135rem;
	width: 100%; */
	background-color: #ffffff;
	@media screen and (max-width: 1370px) {
		padding: 8rem 2rem;
	}
	@media screen and (max-width: 900px) {
		padding: 6rem 2rem;
	}
	.content {
		padding: 2rem;
		font-size: ${(props) => props.theme.fontSize.sizeLg};
	}
`;

export const NoticeList = styled.ul`
	display: flex;
	flex-direction: column;
	padding: 2rem 3.2rem;
	.last {
		border-bottom: none;
	}
`;
export const NoticeEmptyBox = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
`;
export const NoticeListItem = styled.li`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	padding: 1.2rem 0;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	letter-spacing: -0.6px;
	line-height: 100%;
	border-bottom: 1px solid #e9ecef;
	cursor: pointer;
	.title {
		color: #212529;
	}
	.sub_title {
		color: #868e96;
	}
`;

export const Divider = styled.div`
	width: 1px;
	height: 29px;
	background-color: #dee2e6;
	margin: 0 1.6rem;
`;
export const EmptyEl = styled.div``;

export const NoticeContent = styled.div`
	margin: 0 auto;
	max-width: 135rem;
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 2rem;
`;
export const NoticeContentList = styled.div`
	display: flex;
	gap: 3.2rem;
	justify-content: space-between;
	width: 100%;
	@media screen and (max-width: 900px) {
		flex-direction: column;
		gap: 1.6rem;
	}
`;

export const CardImg = styled.div<{ bgImg: string }>`
	background-image: url(${(props) => props.bgImg});
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	background-clip: border-box;
	background-origin: border-box;
	position: relative;
	display: flex;
	border-radius: 1.2rem;
	flex: 1;
	min-height: 56rem;
	max-height: 60rem;
	width: 100%;
	cursor: pointer;
	@media screen and (max-width: 900px) {
		min-height: 36rem;
		max-height: none;
		border-radius: 0.8rem;
	}

	.title_box {
		display: flex;
		flex-direction: column;
		gap: 1.2rem;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		@media screen and (max-width: 900px) {
			left: 50%;
			right: auto;
			transform: translate(-50%, -50%);
			width: calc(100% - 3.2rem);
			padding: 0 1.6rem;
			gap: 0.8rem; /* 모바일: 요소 간 간격 축소 */
		}
		.title {
			color: #222;
			font-size: 28px;
			font-weight: 500;
			line-height: 2.25rem;
			letter-spacing: -0.07rem;
			text-align: center;
			@media screen and (max-width: 900px) {
				font-size: 20px;
				line-height: 130%;
				margin-bottom: 16px; /* 모바일: 제목-중간제목 간격 축소 */
			}
			margin-bottom: 32px; /* 기본 간격 */
		}
		.mid_title {
			color: #233f84;
			font-size: 48px;
			font-weight: 700;
			font-style: normal;
			text-align: center;
			line-height: 2.25rem;
			letter-spacing: -0.12rem;
			margin-bottom: 32px; /* 기본 간격 */
			@media screen and (max-width: 900px) {
				font-size: 32px;
				line-height: 130%;
				margin-bottom: 12px; /* 모바일: 간격 더 축소 */
			}
		}
		.sub_title {
			color: #222;
			font-size: 20px;
			font-weight: 300;
			line-height: 32px;
			letter-spacing: -0.8px;
			text-align: center;
			@media screen and (max-width: 900px) {
				font-size: 16px;
				line-height: 150%;
				margin-top: 4px; /* 모바일: 위 요소와 간격 축소 */
			}
			@media screen and (max-width: 660px) {
				br {
					display: none;
				}
			}
		}
	}
	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: 1.6rem;
	}
`;

// PC: 가운데 정렬 가로 배치 (왼쪽 이미지 / 오른쪽 텍스트, 간격 포함)
// Mobile: 세로 스택 (이미지 위, 텍스트 아래)
export const GreetingBox = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 120px; /* 둘 사이 간격 120px */
	width: 100%;
	margin-top: 4rem; /* 상단(설명 텍스트)과의 간격 확대 */

	@media screen and (max-width: 900px) {
		flex-direction: column;
		align-items: center; /* 모바일에서 가운데 정렬 */
		gap: 1.25rem;
	}
`;

export const GreetingImg = styled.div`
	flex: 0 0 auto;
	img {
		width: 400px; /* 400 x 400 */
		height: 400px;
		object-fit: cover;
		border-radius: 8px; /* 필요시 원형은 50% */
	}

	@media screen and (max-width: 900px) {
		img {
			width: 200px; /* 모바일 축소 */
			height: 200px;
		}
	}
`;

export const GreetingText = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0; /* 개별 간격은 margin으로 제어 */
	max-width: 550px; /* 텍스트 가로 최대값 */
	text-align: left;
	width: 100%;

	@media screen and (max-width: 900px) {
		max-width: 100%;
	}
`;

export const GreetingNameRow = styled.div`
	display: flex;
	align-items: baseline;
	gap: 0.75rem;
	margin-bottom: 32px; /* 이름/직함과 본문 사이 32px */
`;

export const GreetingName = styled.span`
	font-size: 36px; /* 이름 36px */
	font-weight: 700;
	letter-spacing: -0.02rem;

	@media screen and (max-width: 900px) {
		font-size: 24px; /* 모바일 축소 */
	}
`;

export const GreetingPosition = styled.span`
	font-size: 24px; /* 직함 24px */
	font-weight: 500;
	color: #555;

	@media screen and (max-width: 900px) {
		font-size: 18px; /* 모바일 축소 */
	}
`;

export const GreetingMessage = styled.p`
	font-size: 20px; /* 본문 20px */
	line-height: 1.6;
	color: #666;
	white-space: pre-line;
	margin-top: 0; /* 위에서 32px 간격 지정 */

	@media screen and (max-width: 900px) {
		font-size: 16px; /* 모바일 축소 */
	}
`;

export const NoticeButtonTab = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
`;
export const ButtonList = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`;

export const TabButton = styled.div<TabButtonProps>`
	font-size: ${(props) => props.theme.fontSize.size4xl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
	background: none;
	color: ${(props) => (props.isActive ? '#212529' : '#adb5bd')};
	border: none;
	cursor: pointer;
	@media screen and (max-width: 900px) {
		font-weight: ${(props) => props.theme.fontWeight.weightBold};
	}
`;

export const NoticeTabList = styled.div`
	display: flex;
	gap: 3.2rem;
`;

export const Wrapper = styled.div`
	display: flex;
	width: 50%;
	justify-content: space-between;

	@media screen and (max-width: 900px) {
		width: 100%;
		gap: 2.4rem;
		flex-direction: column;
	}
`;

export const GotoButton = styled.button`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 0.8rem;
	border: none;
	background: none;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 100%;
	letter-spacing: -0.6px;
	color: #495057;
	cursor: pointer;
	@media screen and (max-width: 900px) {
		justify-content: flex-end;
	}
`;

export const ContentCard = styled.div`
	border-radius: 1.6rem;
	background-color: #fff;
`;

export const Company = styled.div`
	padding: 8rem 0;
	max-width: 135rem;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	gap: 3.2rem;
	@media screen and (max-width: 1370px) {
		padding-left: 2rem;
	}
	.title {
		font-size: ${(props) => props.theme.fontSize.size4xl};
		font-weight: ${(props) => props.theme.fontWeight.weightSemi};
		line-height: 130%;
		letter-spacing: -0.6px;
		color: #212529;
	}
	.swiper {
		--swiper-space-between: 16px;
	}
	.swiper-wrapper {
	}
	.swiper-slide {
		width: unset;
		height: 14.7rem;
		/* height: 16.2rem; */
	}
	.swiper-button-prev {
		right: 4.6rem;
		top: unset;
		bottom: 0;
		left: unset;
		color: #868e96;
		@media screen and (max-width: 900px) {
			right: 6.6rem;
		}
	}
	.swiper-button-next {
		right: 0rem;
		top: unset;
		bottom: 0;
		color: #868e96;
		@media screen and (max-width: 900px) {
			right: 2rem;
		}
		/* width: 2.2rem; */
	}
	.swiper-button-prev::after {
		color: var(--color-base-white);
		font-size: var(--font-s-small);
		font-weight: var(--font-w-light);
		line-height: 1.551rem;
	}
	.swiper-button-next::after {
		color: var(--color-base-white);
		font-size: var(--font-s-small);
		font-weight: var(--font-w-light);
		line-height: 1.551rem;
	}
`;

export const CompanyCard = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 1.6rem;
	background-color: #f8f9fa;
	width: 21.2rem;
	height: 9.1rem;
	img {
		max-width: 14rem;
		width: 100%;
	}
`;
export const EmptyData = styled.p`
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%;
	letter-spacing: -0.6px;
	text-align: center;
`;

export const GreetingSection = styled.section`
	width: 100%;
	background-color: #ebf1ff; /* 섹션 전체 배경 */
	margin-top: 5rem; /* 이전 섹션(Notice)과 간격 */
`;

export const FeatureCardRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 2.4rem;
	flex-wrap: wrap;
`;

export const FeatureImgBox = styled.div`
	/* width: clamp(200px, 80vw, 340px); */
	width: 100%;
	aspect-ratio: 1 / 1;
	display: flex;
	align-items: center;
	justify-content: center;
	img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}
	@media screen and (max-width: 600px) {
		width: 100%;
	}
`;

export const FeatureCardSubTitle = styled.p`
	font-size: 20px;
	font-weight: 300; /* 요청: 서브타이틀 300 */
	line-height: 140%;
	letter-spacing: -0.6px;
	text-align: center;
	@media screen and (max-width: 600px) {
		font-size: 16px;
		line-height: 140%;
		word-break: keep-all;
		overflow-wrap: anywhere;
	}
`;

export const FeatureRowGrid = styled.div`
	display: grid;
	grid-template-columns: 1fr auto 1fr auto 1fr;
	align-items: start; /* 플러스 정렬 보정 위해 상단 기준 */
	justify-items: stretch; /* 카드 가로폭을 컬럼 너비에 맞춰 동일하게 */
	column-gap: 2.4rem;
	width: 100%;

	/* 이 섹션에서만 카드 내부 이미지-텍스트 간격 40px 적용 */
	.feature-card {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 40px;
	}

	@media screen and (max-width: 1100px) {
		grid-template-columns: 1fr; /* 카드 단일 컬럼 */
		row-gap: 2.4rem;
		.feature-card {
			gap: 20px;
		}
	}
	@media screen and (max-width: 600px) {
		row-gap: 1.2rem; /* 모바일: 카드 간 간격 축소 */
		padding: 0 1.2rem; /* 모바일: 좌우 여백 확보로 넘침 방지 */
	}
`;

export const Plus = styled.div`
	width: 40px;
	height: 40px;
	position: relative;
	align-self: start;
	top: 220px; /* 중앙보다 약간 아래로 미세 조정 */
	transform: translateY(-50%);

	@media screen and (max-width: 1100px) {
		display: none;
	}

	/* 얇은 + 구현 (수평/수직 라인) */
	&::before,
	&::after {
		content: '';
		position: absolute;
		left: 50%;
		top: 50%;
		background: #adb5bd;
		transform: translate(-50%, -50%);
	}
	&::before {
		width: 100%;
		height: 1px; /* 얇게 */
	}
	&::after {
		width: 1px; /* 얇게 */
		height: 100%;
	}
`;

export const DirectionsSection = styled.section`
	width: 100%;
	background: #fafafa; /* 섹션 배경 */
`;

export const DirectionsInner = styled.div`
	margin: 0 auto;
	max-width: 135rem;
	width: 100%;
	padding: 6rem 0; /* 상단 여백 축소 */
	display: grid;
	grid-template-columns: 1fr 440px; /* 왼쪽: 지도, 오른쪽: 주소 카드 */
	gap: 2.4rem;
	margin-top: -2rem; /* 제목/서브타이틀과의 간격 추가 축소 */

	@media screen and (max-width: 1200px) {
		padding: 4rem 2rem;
		margin-top: -1.2rem;
	}
	@media screen and (max-width: 900px) {
		grid-template-columns: 1fr; /* 모바일: 세로 스택 */
		gap: 1.6rem;
		margin-top: -1rem;
		padding: 2rem 1.6rem; /* 모바일: 좌우 여백 확보로 넘침 방지 */
	}
	@media screen and (max-width: 600px) {
		padding: 1.6rem; /* 더 작은 화면에서 좌우 여백 추가 */
	}
`;

export const AddressCardGroup = styled.div`
	display: flex;
	flex-direction: column;
	gap: 15px; /* 카드 간 상하 간격 5px */
	height: 420px; /* 지도와의 높이 균형 조정 */
	@media screen and (max-width: 900px) {
		height: auto; /* 모바일: 내용에 맞춤 */
	}
`;

export const MapPanel = styled.div`
	width: 100%;
	height: 420px; /* 주소 카드 그룹과 동일 고정 높이 */
	background: #e9ecef; /* 임시 배경 (카카오맵 삽입 영역) */
	border-radius: 16px;
	overflow: hidden;

	#map {
		width: 100%;
		height: 100%;
	}
	@media screen and (max-width: 600px) {
		height: 320px; /* 모바일: 지도 높이 축소 */
		border-radius: 12px;
	}
`;

export const AddressCard = styled.div`
	width: 440px;
	max-width: 100%;
	border-radius: 16px;
	background: #fff;
	padding: 2.4rem; /* 내부 여백 확대 */
	display: flex;
	flex-direction: column;
	gap: 1.2rem;
	@media screen and (max-width: 900px) {
		width: 100%; /* 모바일: 카드가 화면폭을 넘지 않도록 */
		border-radius: 12px;
		padding: 1.6rem;
	}

	.title_wrap {
		display: flex;
		align-items: center;
		gap: 0.8rem;

		.icon {
			width: 24px;
			height: 24px;
			object-fit: contain;
		}

		.title {
			color: var(--color-font-default, #222);
			font-family: 'Pretendard Variable';
			font-size: 20px;
			font-style: normal;
			font-weight: 600;
			line-height: 36px; /* 180% */
			letter-spacing: -0.8px;
		}
	}

	.c_info_list {
		display: flex;
		flex-direction: column;
		gap: 0.6rem;

		/* 기본 항목(점 필요) */
		.item {
			position: relative;
			padding-left: 0.9rem; /* 점과의 간격 */
			color: var(--color-font-default, #222);
			font-family: 'Pretendard Variable';
			font-size: 18px;
			font-style: normal;
			font-weight: 300;
			line-height: 28px; /* 155.556% */
			letter-spacing: -0.72px;
		}
		.item::before {
			content: '';
			position: absolute;
			left: 0;
			top: 14px; /* 28px line-height의 정확한 중간(14px) */
			width: 6px;
			height: 6px;
			border-radius: 50%;
			background: #adb5bd; /* 회색 점 */
			transform: translateY(-50%);
		}

		/* 지하철/버스 항목(점 유지 + strong 색상, 개행 제어) */
		.item strong {
			display: block; /* 기본: 개행 */
			margin-bottom: 2px;
		}
		.item.subway strong {
			display: inline; /* 지하철은 개행하지 않음 */
			margin-bottom: 0;
			color: #37af44;
		}
		.item.bus--blue strong {
			color: #3162e5;
		}
		.item.bus--green strong {
			color: #3ea61a;
		}
	}
`;
